export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ16.6b5d95b1.mp3";